import React, {useState} from 'react';
import {View, Text, StyleSheet, TouchableOpacity, FlatList} from 'react-native';
import CustomButton from '../../../commonComponents/CustomButton';

const ClubOptionsSettle = ({
  orderStatus,
  clubEventDetails,
  onDifferentOptions,
  optionSelectedIndex,
}) => {
  const onPlaceOrder = async () => {
    orderStatus({isSettleConfirmation: true});
  };
  return (
    <View style={{marginVertical: -10}}>
      <CustomButton
        btnText={'Proceed'}
        btnType="normalBlue"
        onBtnClick={onPlaceOrder}
      />
      <CustomButton />
    </View>
  );
};

export default ClubOptionsSettle;
